module.exports = __webpack_public_path__ + "static/media/google-meet-icon.4b9197d6.svg";